import moment, { Moment } from 'moment'

export const MAX_MONTHS = 18

export const startOfToday = (): Moment => moment().startOf('day')

export const toDay = (value: Moment): Moment => value.clone().startOf('day')

export const maxTo = (from: Moment): Moment =>
  toDay(from).add(MAX_MONTHS, 'months').subtract(1, 'day')

export const isFutureDate = (current: Moment): boolean =>
  toDay(current).isAfter(startOfToday(), 'day')

export const isToOutsideRange = (from: Moment, to: Moment): boolean =>
  toDay(to).isBefore(toDay(from), 'day') ||
  toDay(to).isAfter(maxTo(from), 'day')

export const disabledFromDate = (current: Moment | null): boolean => {
  if (!current) return false
  return isFutureDate(current)
}

export const disabledToDate = (
  current: Moment | null,
  from: Moment | null
): boolean => {
  if (!current) return false
  if (isFutureDate(current)) return true
  if (!from) return false
  return (
    toDay(current).isBefore(toDay(from), 'day') ||
    toDay(current).isAfter(maxTo(from), 'day')
  )
}

export const rangeDayClassName = (
  current: Moment,
  from: Moment | null,
  to: Moment | null
): string => {
  if (!from || !to) return ''
  const day = toDay(current)
  if (day.isSame(from, 'day')) return 'dc4-range-start'
  if (day.isSame(to, 'day')) return 'dc4-range-end'
  if (day.isAfter(from, 'day') && day.isBefore(to, 'day')) return 'dc4-in-range'
  return ''
}
